import {host} from './host';
export const url=`http://${host}:5000`;

// export const url='https://bked.astharaagro.com';
